import { cloneDeep, get } from "lodash-es";

import menus from "@/layouts/menu/menu";
import menuInternal from "@/layouts/menu/menuInternal";
import version from "@/static/version";

export default {
  beforeCreate() {
    // https://github.com/nuxt/nuxt.js/issues/4764#issuecomment-713469389 issue
    // check version
    if (version.version !== localStorage.getItem("qoalaPortalVersion")) {
      localStorage.setItem("qoalaPortalVersion", version.version); // set to be the same
      this.$store.dispatch("appPersisted/destroyStates"); // destroy persist table listing

      window.location.reload();
    }
  },

  async created() {
    // === setup menu ===
    // based on external or internal dashboard
    if (!this.isInternalDashboard) {
      // external dashboard or default
      this.menus = cloneDeep(menus);
    } else {
      // internal dashboard menu
      this.menus = cloneDeep(menuInternal);
    }

    if (!this.$store.getters["auth/getUserToken"]) {
      this.$store.dispatch("auth/authDestroy");
    }

    this.setTheme();

    // set airtable
    // NOTE:
    // disabled for temporary, needs confirmation
    // if (typeof this.content !== 'undefined'
    // && this.content !== null
    // && typeof this.content === 'object'
    // && typeof this.content.QoalaExternalDashboardProfile !== 'undefined'
    // ) {
    //     // set profile airtable to state
    //     this.$store.dispatch('app/setProfileMenu', this.content);
    // }

    // locale validation
    this.checkingLocale();

    // set organisation logo
    this.$store.dispatch(
      "appPersisted/setLogo",
      get(this.$store.getters["auth/getUserData"], "organization.logo", ""),
    );

    // set menu
    if (this.$store.getters["auth/getUserData"]) {
      this.myMenu = cloneDeep(this.defineVisibility());
    } else {
      this.myMenu = cloneDeep(this.menus);
    }
  },
};
